import React from "react";
import ECLBlock from "../ECLBlock";
import ECLBlockument from "../ECLBlockument";

export default function DocumentBlock(props) {
   const docKey = props.block.data.document_link.id + "_root";
   //If this document has already been loaded, don't render
   if (props.headlist.includes(docKey)) {
      return null;
   }

   if (Object.keys(props.flatDoc).includes(docKey)) {
      //Once the document is initialized in the flat main doc, render as blocks
      return (
         <>
            {props.flatDoc[docKey].children.map((c) => {
               return (
                  <ECLBlock
                     key={c}
                     block={props.flatDoc[c]}
                     project={props.project}
                     flatDoc={props.flatDoc}
                     setFlatDoc={props.setFlatDoc}
                     flatKey={c}
                     headlist={[...props.headlist, docKey]}
                     parentDoc={
                        props.parentDoc
                           ? props.parentDoc + props.flatKey
                           : props.flatKey
                     }
                     revisionCount={props.revisionCount}
                     incrementRevision={props.incrementRevision}
                  />
               );
            })}
         </>
      );
   }
   //render as special invisible blockument so we can load new doc and add it to parent flat doc
   return (
      <ECLBlockument
         project={props.project}
         object={{
            id: props.block.data.document_link.id,
            meta: { revisionId: props.block.data.document_link.rev },
         }}
         flatDoc={props.flatDoc}
         setFlatDoc={props.setFlatDoc}
         parent={
            props.parentDoc ? props.parentDoc + props.flatKey : props.flatKey
         }
         headlist={[...props.headlist, docKey]}
      />
   );
}
